import {useNavigate} from "react-router-dom";
import {FaArrowLeft, FaBan} from "react-icons/fa6";
import {FaInfoCircle} from "react-icons/fa";
import ProfileService from "../../../../services/Profile";
import React, {useEffect, useState} from "react";

export default function BanHistory() {
    const navigate = useNavigate();
    const [banHistory, setBanHistory] = useState([]);
    const fixDate = (iso) => {
        const d = new Date(iso);
        const date = d.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });

        const time = d.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
        });

        return `${date} - ${time}`;
    };

    async function getMyBanHistory() {
        try {
            const res = await ProfileService.getMyBanHistory();
            setBanHistory(res?.data?.message);
        } catch (err) {
            console.log("err:", err);
        }
    }

    useEffect(() => {
        getMyBanHistory();
    }, []);


    function calcDays(start, end) {
        const s = new Date(start);
        const e = new Date(end);
        const diff = e - s;
        return Math.ceil(diff / (1000 * 60 * 60 * 24));
    }


    function getStatusClasses(type) {
        const map = {
            unBan: "bg-green-50 border-green-200",
            ban: "bg-red-50 border-red-100",
            permanent: "bg-red-50 border-red-100",
            temporary: "bg-red-50 border-red-100",
            warning: "bg-orange-50 border-orange-200",
        };

        return map[type] || "bg-gray-50 border-gray-200";
    }

    return (
        <div dir="ltr">
            <div className="bg-gray-50 min-h-screen pb-20">
                <header className="fixed top-0 left-0 right-0 shadow-sm z-50 bg-white px-5 py-4">
                    <div className="flex items-center justify-between">
                        <button
                            onClick={() => navigate("/profile")}
                            className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-all"
                        >
                            <FaArrowLeft className="text-gray-600"/>
                        </button>
                        <h1 className="text-xl font-bold text-gray-900">Ban History</h1>
                        <div className="w-10"></div>
                    </div>
                </header>

                <section className="px-4 py-4 mt-20">
                    <div className="bg-blue-50 rounded-2xl p-4 mb-6 border border-blue-200">
                        <div className="flex items-start">
                            <FaInfoCircle className="text-blue-600 text-lg mr-3 mt-0.5"/>
                            <div>
                                <h4 className="font-semibold text-gray-900 mb-1">
                                    Important Information
                                </h4>
                                <p className="text-sm text-gray-700">
                                    If you believe any restriction has been applied in error,
                                    please contact our support team. We review every case
                                    thoroughly.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="space-y-4">
                        <div className="space-y-5">
                            {banHistory.length > 0
                                ?
                                banHistory.map((item) => (
                                    <div
                                        key={item?._id}
                                        className="bg-white rounded-2xl border border-gray-200 overflow-hidden"
                                    >
                                        <div className="p-4">
                                            <div className="flex items-start justify-between mb-3">
                                                <div className="flex items-start">
                                                    <div
                                                        className={`w-10 h-10 rounded-xl flex items-center justify-center mr-3 flex-shrink-0 ${getStatusClasses(
                                                            item.type,
                                                        )}`}
                                                    >
                                                        <FaBan className="text-red-600 text-lg"/>
                                                    </div>
                                                    <div>
                          <span className="font-semibold text-gray-900">
                            {item.type}
                          </span>
                                                        <div className="text-sm text-gray-500 mt-1">-</div>
                                                    </div>
                                                </div>

                                                <span
                                                    className={` px-3 py-1 rounded-full text-xs font-medium ${
                                                        item.type === "ban"
                                                            ? "text-red-900"
                                                            : item.type === "unBan"
                                                                ? "text-green-900"
                                                                : item.type === "temporary"
                                                                    ? "text-red-400"
                                                                    : item.type === "permanent"
                                                                        ? "text-green-900"
                                                                        : "text-gray-500"
                                                    } ${getStatusClasses(item.type)}`}
                                                >
                        Active
                      </span>
                                            </div>

                                            <div className="bg-gray-50 rounded-xl p-3 space-y-2">
                                                <div className="flex justify-between text-sm">
                                                    <span className="text-gray-600">Start Date:</span>
                                                    <span className="font-medium text-gray-900">
                          <p className="text-xs text-gray-400">
                            {item?.bannedAt ? fixDate(item?.bannedAt) : "-"}
                          </p>
                        </span>
                                                </div>

                                                <div className="flex justify-between text-sm">
                                                    <span className="text-gray-600">End Date:</span>
                                                    <span className="font-medium text-gray-900">
                          <p className="text-xs text-gray-400">
                            {item?.expiresAt ? fixDate(item?.expiresAt) : "-"}
                          </p>
                        </span>
                                                </div>
                                                <div className="flex justify-between text-sm">
                                                    <span className="text-gray-600">Duration:</span>
                                                    <span className="font-medium text-red-600">
                          {calcDays(item.bannedAt, item.expiresAt) || "-"} days
                        </span>
                                                </div>
                                            </div>

                                            <div
                                                className={`mt-3 p-3 rounded-xl border ${getStatusClasses(
                                                    item.type,
                                                )}`}
                                            >
                                                <p className="text-sm text-gray-700">{item.reason}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))
                                :
                                <p className={'text-sm text-gray-900 w-full text-center'}>
                                    No ban history found.
                                </p>
                            }
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}